import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SessionService } from '../../providers/session.service';
import { EntryBuilderService } from '../../providers/entry-builder.service';
import { HorseShowService } from '../../providers/horse-show.service';
import { AccessCodeService } from '../../providers/access-code.service';
import { Horse_show } from '../../models/horse_show';

import { User } from '../../models/user';
import { faSpinner, faUser, faPlus } from '@fortawesome/fontawesome-pro-regular';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { ModalEnterAccessCodeComponent } from '../../components/modal-enter-access-code/modal-enter-access-code.component';

import { faHorseHead, faPlusCircle, faHomeAlt, faMapMarked, faAddressCard, faPhoneOffice, faHotel, faPlaneArrival, faLock, faFlagUsa, faCalendar, faAward, faBell, faList, faMinusCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCanadianMapleLeaf } from '@fortawesome/free-brands-svg-icons';

import * as dayjs from 'dayjs';


@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
styleUrls:  ['./home.component.css']
})

export class HomeComponent extends SmsAbstractAppPage implements OnInit {

   horse_shows: Array<Horse_show> = [];
   navigation_in_progress: boolean = false;
   faSpinner = faSpinner;
   faUser = faUser;
   faPlusCircle = faPlusCircle;
   faHorseHead = faHorseHead;
   faHomeAlt = faHomeAlt;
   faMapMarked = faMapMarked;
   faAddressCard = faAddressCard;
   faPhoneOffice = faPhoneOffice;
   faHotel = faHotel;
   faPlaneArrival = faPlaneArrival;
   faLock = faLock;
   faFlagUsa = faFlagUsa;
   faCanadianMapleLeaf = faCanadianMapleLeaf;
   faCalendar = faCalendar;
   faAward = faAward;
   faBell = faBell;
   faList = faList;
   faMinusCircle = faMinusCircle;

   active: boolean = false;

  constructor(private horseShowService: HorseShowService,
    private accessCodeService: AccessCodeService,
    private entryBuilderService: EntryBuilderService,
    private router: Router,
    private modal: NgbModal) {
    super();
  }

  ngOnInit() {

    this.horseShowService.getLive().then(horse_shows => {
      this.horse_shows = horse_shows;
      this.accessCodeService.getAccessList().then(access_codes => {
        access_codes.forEach((code, i) => {
          this.horse_shows.forEach((horse_show, j) => {

            if(code.horse_show_id == horse_show.id){
              horse_show.restricted_event_unlocked = true;
            }
          });

        });
      }).catch(error => {
        this.handleError(error);
      })
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleCreateEntry(horse_show: Horse_show){
    this.navigation_in_progress = true;
    this.entryBuilderService.reset();
    this.router.navigate(['create-horse-show-entry/add-horse-and-people/' + horse_show.id]);
  }

  handleChooseDiscipline(horse_show: Horse_show){
    this.navigation_in_progress = true;
    this.entryBuilderService.reset();
    this.router.navigate(['create-horse-show-entry/select-discipline/' + horse_show.id]);
  }

  handleNominateRider(horse_show: Horse_show){
    this.navigation_in_progress = true;
    this.entryBuilderService.reset();
    this.router.navigate(['nominate-rider/add-rider/' + horse_show.id]);
  }

  handleCreateBarnAccount(horse_show: Horse_show){
    this.navigation_in_progress = true;
    this.entryBuilderService.reset();
    this.router.navigate(['create-barn-account/add-person/' + horse_show.id]);
  }

  handleDisplayOrganizerInformation(organizer_id: string){
   this.navigation_in_progress = true;
    this.router.navigate(['organizer-information/' + organizer_id]);
  }

  public getFullCountryName(country_code: string){
    switch(country_code) {
      case 'USA': return "United States";
      case "CAN": return "Canada";
      default: return "Canada";
    }
  }

   handleEnterAccessCode(horse_show: Horse_show){
      const modal_ref_access = this.modal.open(ModalEnterAccessCodeComponent, {size: 'lg'});

      modal_ref_access.componentInstance.horse_show_id = horse_show.id;

      modal_ref_access.componentInstance.horse_show_unlocked$.subscribe(responding_id => {

        if(responding_id == horse_show.id){
          horse_show.restricted_event_unlocked = true;
          modal_ref_access.close();
        }
      },
        error => {
          this.handleError(error);
        });

  }

}
